const internals = {};

exports.getClientPlatform = ({
    isCordova = typeof window !== 'undefined' && !!window.cordova,
    maxTouchPoints = typeof navigator !== 'undefined' ? navigator.maxTouchPoints : 0,
    userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : ''
} = {}) => {

    if (isCordova) {
        return 'mobile';
    }

    const normalizedUserAgent = typeof userAgent === 'string' ? userAgent : '';
    const mobileUserAgent = /Android|iPhone|iPad|iPod|Mobile|Tablet|Silk|Kindle|PlayBook|IEMobile|Opera Mini/i.test(normalizedUserAgent);
    const iPadDesktopMode = /Macintosh/i.test(normalizedUserAgent) && Number(maxTouchPoints) > 1;

    return mobileUserAgent || iPadDesktopMode ? 'mobile' : 'desktop';
};

exports.isSchoolPolicyRuleEnabled = ({ policy, rule, platform = exports.getClientPlatform() } = {}) => {

    try {
        if (!internals.isObject(policy) || policy.version !== 1 || !internals.isObject(policy.rules)) {
            return false;
        }

        const configuredRule = policy.rules[rule];

        if (!internals.isObject(configuredRule) || !['desktop', 'mobile'].includes(platform)) {
            return false;
        }

        if (typeof configuredRule.platforms === 'undefined') {
            return true;
        }

        if (!Array.isArray(configuredRule.platforms) || !configuredRule.platforms.length) {
            return false;
        }

        if (configuredRule.platforms.some((value) => !['desktop', 'mobile', 'all'].includes(value))) {
            return false;
        }

        return configuredRule.platforms.includes('all') || configuredRule.platforms.includes(platform);
    }
    catch (err) {
        return false;
    }
};

internals.isObject = (value) => !!value && typeof value === 'object' && !Array.isArray(value);
